import {CPaymentLinkStatuses} from '@/app/main/paymentLink/models/constants';
import {PaymentLinkV2Error} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Error/PaymentLinkV2Error';
import {PaymentLinkV2Expired} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Expired/PaymentLinkV2Expired';
import {PaymentLinkV2Skeleton} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Skeleton/PaymentLinkV2Skeleton';
import {PaymentLinkV2Valid} from '@/app/main/paymentLink/v2/pages/paymentLinkV2/components/PaymentLinkV2Valid/PaymentLinkV2Valid';

import {
  PaymentLinkV2ViewModelProvider,
  usePaymentLinkV2ViewModel,
} from './ViewModelContext';

const PaymentLinkV2Content = () => {
  const {status, validLinkProps, paymentLinkId} = usePaymentLinkV2ViewModel();
  if (status === CPaymentLinkStatuses.LOADING) {
    return <PaymentLinkV2Skeleton />;
  }

  switch (status) {
    case CPaymentLinkStatuses.VALID:
      return <PaymentLinkV2Valid {...validLinkProps} />;
    case CPaymentLinkStatuses.USED:
      return <PaymentLinkV2Expired props={validLinkProps} />;
    case CPaymentLinkStatuses.ERROR:
      return <PaymentLinkV2Error paymentLinkId={paymentLinkId} />;
    default:
      return (
        <PaymentLinkV2Error
          paymentLinkId={paymentLinkId}
          isNotFoundError
        />
      );
  }
};

const PaymentLinkV2Page = () => (
  <PaymentLinkV2ViewModelProvider>
    <PaymentLinkV2Content />
  </PaymentLinkV2ViewModelProvider>
);

export default PaymentLinkV2Page;
